var REFERENCE_COLOR = 'rgb(200, 100, 50)';

var isHighContrast = function isHighContrast() {
  // Check if it is first render in SSR
  if (typeof window === 'undefined') {
    return false;
  } // Detect if the os is windows


  if (navigator.userAgent.indexOf('Win') === -1) {
    return false;
  }

  var highContrastTestDivEl = document.createElement('div');
  highContrastTestDivEl.style.color = REFERENCE_COLOR;
  document.body.appendChild(highContrastTestDivEl);
  var color = document.defaultView && document.defaultView.getComputedStyle(highContrastTestDivEl, null).color;
  document.body.removeChild(highContrastTestDivEl);
  return color !== REFERENCE_COLOR;
};

export default isHighContrast;